import { splitClassName } from '../../../../utils/classnames-utils';
import { getMaxContents, getMaxVideoContents } from '../../../utils/get-max-contents';
import { getParselyUuid } from '../../../utils/get-parsely-uuid';

const getCommonVariables = (htmlProps) => ({
  widgetId: htmlProps.widgetId,
  parselyUUID: getParselyUuid(),
  maxContents: getMaxContents(htmlProps),
  maxVideoContents: getMaxVideoContents(htmlProps),
});

const getTitle = (state, htmlProps) => state.widgetHeading || htmlProps.defaultWidgetTitle;

const getSectionTitleModifiers = ({ authState, state, widget }) =>
  authState.isUserLogged && state.userPreferences?.length
    ? [widget.styles.sectionTitleActiveColor]
    : [widget.styles.sectionTitleColor];

const getShowRemoveConsent = (authState, parselyCommonState) =>
  authState.isUserLogged && parselyCommonState.currentConsent;

const getMessageCard = (state, widget) => state.messages?.find((message) => message.id === widget.messageIdToShow);

/**
 * Get values derived from the internal variables
 * @param {object}
 * @returns {object}
 * NOTE: Use parseDataParsely (utils/parsers) to get values derived from the service
 */
export const getDerivedValues = ({ state, htmlProps = {}, widget, authState, parselyCommonState }) => ({
  title: getTitle(state, htmlProps),
  commonVariables: getCommonVariables(htmlProps),
  setOfCarsModifierList: splitClassName(widget.styles.setsOfCardsModifiers),
  sectionTitleModifiers: getSectionTitleModifiers({ authState, state, widget }),
  showRemoveConsent: getShowRemoveConsent(authState, parselyCommonState),
  messageCard: getMessageCard(state, widget),
});

export function getTagSelectName(state, widget, htmlProps) {
  if (state.userPreferences.length === 0) {
    return widget.tagSelectDefaultText;
  }
  return htmlProps.maxOptions === 1 ? state.userPreferences[0].config.labelCta : widget.tagSelectEditText;
}
